import React, { memo, useCallback } from 'react';
import { Doc as DocModel, DocStatus, DocStatusName } from '@app/models';
import { Info } from '@app/components';
import { currencyFormat, dateFormat, fullName } from '@app/helpers';

interface Props {
  doc: DocModel;
  onClick?: (doc: DocModel) => void;
  hideStatus?: boolean;
  hideName?: boolean;
  variant?: 'default' | 'secondary';
}

const statusColor = (status: DocStatus) => {
  switch (status) {
    case 10:
      return 'bg-primary text-primary';
    case 20:
    case 30:
      return 'bg-gray-300 text-gray-500';
    case 40:
      return 'bg-green-500 text-green-700';
    case 50:
      return 'bg-red-500 text-red-700';
    case 60:
      return 'bg-zinc-800 text-zinc-900';
    default:
      return 'bg-muted text-muted-foreground';
  }
};

function Doc(props: Props) {
  const {
    doc,
    onClick,
    hideStatus = false,
    hideName = false,
    variant = 'default',
  } = props;

  const onClickDoc = useCallback(() => {
    if (!!onClick) {
      onClick(doc);
    }
  }, [onClick, doc]);

  return (
    <div
      key={doc.id}
      className={`flex gap-6 items-center rounded-xl ${
        variant === 'secondary' ? '' : 'bg-muted p-4'
      } w-full`}
    >
      <div
        className="grid grid-cols-1 items-center w-full gap-4 cursor-pointer"
        onClick={onClickDoc}
      >
        {!hideStatus && (
          <div className="flex items-center">
            <span
              className={`w-2 h-2 rounded-full mr-2 ${
                statusColor(doc.status).split(' ')[0]
              }`}
            ></span>
            <span
              className={`text-xs font-medium ${
                statusColor(doc.status).split(' ')[1]
              }`}
            >
              {DocStatusName[doc.status]}
            </span>
          </div>
        )}
        {!hideName && (
          <Info
            label="Предмет договора"
            value={doc.name}
            small={true}
            displayedLength={22}
          />
        )}
        <Info
          label="Срок договора"
          value={dateFormat(doc.endDate)}
          small={true}
        />
        <Info
          label="Сумма договора"
          value={currencyFormat(doc.price)}
          small={true}
        />
        <Info
          label="Инициатор"
          displayedLength={22}
          value={!!doc.companyId ? doc.company.name : fullName(doc.owner)}
          small={true}
        />
        <Info
          label="Партнер"
          displayedLength={22}
          value={
            !!doc.recipientCompanyId
              ? doc.recipientCompany.name
              : fullName(doc.recipient)
          }
          small={true}
        />
      </div>
    </div>
  );
}

export default memo(Doc);
